module.exports = "https://static.wanderu.com/static/media/hero-mobile-header.590cbe30.svg";